import React from 'react';

const EyeSlashIcon = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M23 11.5C23 11.9 22.9 12.4 22.6 12.7C22 13.5 21 14.7 19.8 15.8L16.8 12.8C16.9 12.4 17 11.9 17 11.4C17 8.6 14.8 6.4 12 6.4C11.5 6.4 11.1 6.5 10.6 6.6L8.5 4.6C9.6 4.2 10.7 4 12 4C17.5 4 21 8.2 22.6 10.3C22.9 10.6 23 11.1 23 11.5ZM12.3 8.4C13.7 8.6 14.8 9.6 14.9 11L12.3 8.4ZM20.7 20.7C20.3 21.1 19.7 21.1 19.3 20.7C18.6 20 16.6 18 16.6 18C15.3 18.6 13.8 19 12 19C6.5 19 3 14.8 1.4 12.7C1.1 12.4 1 11.9 1 11.5C1 11.1 1.1 10.6 1.4 10.3C2.2 9.3 3.4 7.8 5.1 6.5C5.1 6.5 3.8 5.2 3.3 4.7C2.9 4.3 2.9 3.7 3.3 3.3C3.7 2.9 4.3 2.9 4.7 3.3C8.7 7.3 16.7 15.3 20.7 19.3C21.1 19.7 21.1 20.3 20.7 20.7ZM14.4 15.8L12.9 14.3C10.6 15.1 8.4 12.9 9.1 10.5L7.7 9.1C7.2 9.8 7 10.6 7 11.5C7 14.3 9.2 16.5 12 16.5C12.9 16.5 13.7 16.3 14.4 15.8Z' />
		</svg>
	);
};

export default EyeSlashIcon;
